module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAFVBMVEVHcEyAYN2CX9+AX92AX92AX9x+XtyIAGPpAAAAB3RSTlMAZwpcRDEax1Km1QAAAIVJREFUOMtjYBgFgxEowBhMaBJuMEYKmoQJVAuTI5qEoBOEVhFElxBRgGhAl3AUdoJoEEGTUBE0BWphCoYZCQdAM4IYGFQNRRTQPZIC1ALU4IbhQzZH4SCghgRMvycLmgYLmmEJFDZDYUPhBGzBlSyIVQMDgxoODUBPmOIIetWg0eQ3aAEA02ANaTeg7OIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/center_mark_ic_list_down.png
// module id = 5FzO
// module chunks = 1